<script setup lang="ts">
import { AuthLoginForm } from '@/modules/auth/components';
definePageMeta({
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
  layout: 'guest',
});

useHead({
  title: 'Login',
});
</script>
<template>
  <v-container class="h-screen d-flex align-center">
    <AuthLoginForm data-testid="login-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 500px;
  margin: auto;

  @include desktop-auth-container();
}
</style>
